import { FieldValues, useController, UseControllerProps } from 'react-hook-form';
import type { CountryData } from 'react-phone-input-2';

import { PhoneInput } from '../PhoneInput/PhoneInput';
import { IPhoneInputProps } from '../PhoneInput/types';

export const PhoneInputControlled = <T extends FieldValues>(props: UseControllerProps<T> & IPhoneInputProps) => {
  const { name, control, label, rules, defaultValue, subName, ...restProps } = props;

  const { field, fieldState } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  const { field: subField } = useController({
    // @ts-expect-error
    name: subName ?? '',
    control,
    rules,
    defaultValue,
  });

  const onChange = (
    value: string,
    data: CountryData | object,
    event: React.ChangeEvent<HTMLInputElement>,
    formattedValue: string,
  ) => {
    field.onChange(value, data, event, formattedValue);
    if (subField && 'format' in data) {
      subField.onChange(data.format);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ref, value, ...restField } = field;
  const { error } = fieldState;

  return (
    <>
      <PhoneInput
        label={label}
        fieldError={error}
        {...restField}
        {...restProps}
        value={value ?? ''}
        onChange={onChange}
      />
    </>
  );
};
